import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { UiInnerNotSPALink } from 'src/components/UI/InnerNotSPALink';
import { IconShine } from 'src/components/Icons/ShineIcon';
import { UiButton } from 'src/components/UI/Button';
import { useTHelper } from 'src/utils/i18n';
import { deCommonCurrentPartnerSelector } from 'src/store/commonPart/selector';
import { showPlusSubscriptionModal } from 'src/store/plusSubscription/helpers';
import styles from './styles.module.scss';
import sidebarStyles from '../../styles.module.scss';

type Props = {
  url: string | null;
};

export const SubscriptionButton: FC<Props> = ({ url }) => {
  const { Name } = useSelector(deCommonCurrentPartnerSelector);
  const testId = url ? 'subscriptionLinkLeftMenu' : 'subscriptionLeftMenu';

  const title = useTHelper('leftMenu')('subscribeToPremium', { partner: Name });

  const handleClick = () => showPlusSubscriptionModal('upgradeNow', { canClose: true });

  const className = `${styles.button} ${sidebarStyles.subscriptionButton}`;

  return url ? (
    <UiInnerNotSPALink href={url} className={`btn ${className}`} dataTestId={testId}>
      <IconShine />
      <span>{title}</span>
    </UiInnerNotSPALink>
  ) : (
    <UiButton className={className} onClick={handleClick} dataTestId={testId}>
      <IconShine />
      <span>{title}</span>
    </UiButton>
  );
};
